import { displayNotification, NotificationDurationMs, NotificationType, RootState } from "@next-platform/client-common-core";
import { AnyAction, Dispatch, MiddlewareAPI } from "@reduxjs/toolkit";
import i18next from "i18next";

import { getOfflineNotificationMessage } from "@/components/common/Notification/utils/notification";

const translateNotification = i18next.t.bind(i18next);

export const apiErrorMiddleware = (store: MiddlewareAPI<Dispatch, RootState>) => (next: Dispatch) => (action: AnyAction) => {
  const result = next(action);

  if (action.type?.endsWith("/rejected")) {
    const { notification } = store.getState();

    if (!navigator.onLine && !notification?.isVisible) {
      store.dispatch(
        displayNotification({
          duration: NotificationDurationMs.normal,
          message: getOfflineNotificationMessage(translateNotification),
          type: NotificationType.warning,
        }),
      );
    }
  }

  return result;
};

export default apiErrorMiddleware;
